var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card shadow",on:{"click":_vm.select}},[_c('img',{staticClass:"images",attrs:{"src":_vm.domain.logo}}),_c('div',{staticClass:"card-text"},[_c('span',[_vm._v(_vm._s(_vm.domain.tenantName))]),_c('span',[_vm._v(_vm._s(_vm.domain.domain))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }